import { render, staticRenderFns } from "./GuiasVisaoGeral.vue?vue&type=template&id=44818d32&scoped=true&"
import script from "./GuiasVisaoGeral.vue?vue&type=script&lang=js&"
export * from "./GuiasVisaoGeral.vue?vue&type=script&lang=js&"
import style0 from "./GuiasVisaoGeral.vue?vue&type=style&index=0&id=44818d32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44818d32",
  null
  
)

export default component.exports